import React from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { gameStore } from '../../../../../store/gameStore';

import PayTableSymbolOdds from './payTableSymbolOdds';

const oddsInfoEnumWeb = [
  { id: 0, oddX: 20, oddContainerY: 25, oddsContainerX: 350, oddsContainerY: 475.5 },
  { id: 1, oddX: 20, oddContainerY: 25, oddsContainerX: 585, oddsContainerY: 475.5 },
  { id: 2, oddX: 20, oddContainerY: 25, oddsContainerX: 820, oddsContainerY: 475.5 },
  { id: 3, oddX: 20, oddContainerY: 25, oddsContainerX: 1055, oddsContainerY: 475.5 },
  { id: 4, oddX: 20, oddContainerY: 25, oddsContainerX: 350, oddsContainerY: 610 },
  { id: 5, oddX: 20, oddContainerY: 25, oddsContainerX: 585, oddsContainerY: 610 },
  { id: 6, oddX: 20, oddContainerY: 25, oddsContainerX: 820, oddsContainerY: 610 },
  { id: 7, oddX: 20, oddContainerY: 25, oddsContainerX: 1055, oddsContainerY: 610 },
  { id: 8, oddX: 20, oddContainerY: 25, oddsContainerX: 1055, oddsContainerY: 175 },
  { id: 9, oddX: 20, oddContainerY: 25, oddsContainerX: 730, oddsContainerY: 195 },
];

const PayTableSymbolsOdds = observer(() => {
  const { oddsInfo } = gameStore;

  return (
    <Container name='PayTableOddsContainer'>
      {oddsInfoEnumWeb.map((item, index) => {
        return (
          <Container
            key={item.id}
            x={item.oddsContainerX}
            y={item.oddsContainerY}
            name='PayTableSymbolsOddsContainer'
          >
            {oddsInfo[index]?.map((odd, oddIndex) => {
              return (
                <PayTableSymbolOdds
                  id={item.id}
                  key={`${item.id}${odd}`}
                  odd={odd}
                  oddX={item.oddX || 0}
                  oddY={item.oddY || 0}
                  oddIndex={oddIndex}
                  oddContainerY={item.oddContainerY}
                />
              );
            })}
          </Container>
        );
      })}
    </Container>
  );
});

export default PayTableSymbolsOdds;
